var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("span", {
    staticClass: "fa fa-lg fa-info-circle",
    attrs: { title: _vm.text, "data-html": _vm.html, "data-toggle": "tooltip" }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }